<template>
  <AudioLibrary />
</template>